export default __webpack_public_path__ + "static/media/thunderstorm.9aef87df.mp4";